export enum AutoSaveStatus {
  BeginSave = 'BeginSave',
  SaveSuccess = 'SaveSuccess',
  SaveError = 'SaveError'
}
